<template>
  <van-swipe :show-indicators="false" vertical :autoplay="3000">
    <van-swipe-item v-for='(item,index) in swiperList' :key='index'> 
      <div @click='look(index)'>
        <span class="tag">{{item.tag}}</span>
        <span class="text">{{item.text}}</span>
        <span class="arrow">查看</span>
      </div>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
  import zhugeObj from '@/assets/js/track'
  export default {
    name: 'home-notice',
    data(){
      return {
        swiperList : [
          {
            tag : '收费',
            text : '奢护行业价格重新定义',
            path : 'feeScale'
          },
          {
            tag : '下单',
            text : '点击下单',
            path : 'place'
          }
        ]
      }
    },
    methods:{
      look(index){
        

        let path = this.swiperList[index].path;
        this.$router.push({name:path});
      }
    }
  }
</script>

<style scoped lang="scss">
  .van-swipe{
    // width: 100%;
    width: 690px;
    height: 100px;
    position: relative;
    border-bottom: 2px solid #eee;
    .van-swipe-item{
      height: 100px!important;
      display: flex;
      align-items: center;
      // justify-content: center;
      &>div{
        width: 690px;
        display: flex;
        align-items: center;
        height: 100px;
        // border-bottom: 2px solid #eee;
        span.tag{
          display: block;
          width: 94px;
          height: 38px;
          background: #FF9B5A;
          border-radius: 6px;
          line-height: 38px;
          text-align: center;
          color: #fff;
          font-size: 20px;
        }
        span.text{
          display: block;
          flex: auto;
          margin-left: 10px;
        }
        span.arrow{
          padding-right: 28px;
          color:#999999;
          background: url("/images/public/arrow-right.png") no-repeat right;
          background-size: 14px 22px;
        }
      }
    }
  }
</style>
